import axios from 'axios';

// Configuration de l'API avec PROXY
// Les URLs relatives /api seront proxifiées vers le backend par setupProxy.js
const api = (axios as any).create({
    baseURL: '/api',
    headers: {
        'Content-Type': 'application/json',
    }
});

export default api;